import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';

import Header from './components/header';
import Footer from './components/footer';
import { GlobalStyle } from './components/global';
import Meta from './components/meta';
import EntryMask from './components/entryMask';
import MobileNavigation from './components/navigation/mobileNavigation';
import CookiesDisclaimer from './components/cookiesDisclaimer';
import ErrorBoundary from './components/errorBoundary';
import Routes from './routes';
import store from './store';

import { fetchInitialNavigationFulfilled } from './actions/navigationActions';
import { fetchInitialPageFulfilled } from './actions/pageActions';
import flatten from './helpers/flatten';
import ScrollToTop from './helpers/scrollToTop';
import Modals from './components/modals';
import ContextMenus from './components/contextMenus/contextMenus';

const StyledAppWrapper = styled.div`
	overflow: hidden;
`;

const themeProps = ({ themeReducer }) => ({ themeReducer });

const ThemeContext = connect(themeProps)(({ themeReducer, children }) => {
	return (
		<ThemeProvider theme={themeReducer.theme}>
			{children}
		</ThemeProvider>
	);
});

const App = ({ page, navigation }) => {
	store.dispatch(fetchInitialNavigationFulfilled(navigation));
	store.dispatch(fetchInitialPageFulfilled(page));

	// Flattened array of routes for route mapping
	const routes = [];
	flatten({ Children: navigation }, 'Children', routes);

	return (
		<Provider store={store}>
			<ThemeContext>
				<StyledAppWrapper>
					<Modals />
					<ContextMenus />
					<EntryMask />
					<GlobalStyle />
					<CookiesDisclaimer />
					<Router>
						<ScrollToTop>
							<Meta />
							<Header />
							<MobileNavigation />
							<ErrorBoundary>
								<Routes dispatch={store.dispatch} routes={routes} />
							</ErrorBoundary>
							<Footer />
						</ScrollToTop>
					</Router>
				</StyledAppWrapper>
			</ThemeContext>
		</Provider>
	);
};

export default App;
